import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getCatalogEntry } from '../utils/al-catalog';
import { fetchUserBookmarkKeys, toggleUserBookmark } from '../utils/user-bookmarks';
const initialState = {
    slugs: [],
    status: 'idle',
};
export const fetchStudioBookmarks = createAsyncThunk('studioBookmarks/fetch', async (_void, { rejectWithValue, getState }) => {
    const state = getState();
    const uid = state.auth?.user?.id;
    if (!uid)
        return rejectWithValue('Not signed in');
    try {
        return await fetchUserBookmarkKeys({
            table: 'studio_bookmarks',
            keyColumn: 'studio_slug',
            userId: uid,
        });
    }
    catch (e) {
        return rejectWithValue(e instanceof Error ? e.message : String(e));
    }
});
export const toggleStudioBookmark = createAsyncThunk('studioBookmarks/toggle', async (slug, { rejectWithValue, getState }) => {
    const state = getState();
    const uid = state.auth?.user?.id;
    if (!uid)
        return rejectWithValue('Not signed in');
    if (!getCatalogEntry(slug)) {
        return rejectWithValue('Unknown studio');
    }
    const currentlyBookmarked = (state.studioBookmarks?.slugs ?? []).includes(slug);
    try {
        return await toggleUserBookmark({
            table: 'studio_bookmarks',
            keyColumn: 'studio_slug',
            userId: uid,
            key: slug,
            currentlyBookmarked,
        });
    }
    catch (e) {
        return rejectWithValue(e instanceof Error ? e.message : String(e));
    }
});
const studioBookmarksSlice = createSlice({
    name: 'studioBookmarks',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher((action) => action.type === 'auth/logoutUser/fulfilled' || action.type === 'auth/logoutUser/rejected', () => initialState);
        builder.addCase(fetchStudioBookmarks.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(fetchStudioBookmarks.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.slugs = action.payload;
        });
        builder.addCase(fetchStudioBookmarks.rejected, (state) => {
            state.status = 'failed';
        });
        builder.addCase(toggleStudioBookmark.fulfilled, (state, action) => {
            const { key, bookmarked } = action.payload;
            if (bookmarked) {
                if (!state.slugs.includes(key)) {
                    state.slugs = [key, ...state.slugs];
                }
            }
            else {
                state.slugs = state.slugs.filter((slug) => slug !== key);
            }
        });
    },
});
export default studioBookmarksSlice.reducer;
